export const ApplicationInstallationRoutes = [
  {
    path: 'apps/:app_hash/install',
    lazy: () => import('./applicationInstallation.page'),
  },
] as const
